import axios from "axios";

export const BASE_URL = "https://intrance.onrender.com";

export const API = axios.create({
  baseURL: BASE_URL,
  // timeout: 5000,
});

export const PRIVATE_API = axios.create({
  baseURL: BASE_URL,
  // timeout: 5000,
});

PRIVATE_API.interceptors.request.use((req) => {
  if (localStorage.getItem("accessToken")) {
    req.headers.Authorization = `Bearer ${JSON.parse(
      localStorage.getItem("accessToken")
    )}`;
  }
  return req;
});
